import { Base } from "../base";

export class UpdateSensor extends Base {
    SensorID?: string;
    ParkingID?: number;
    RegistrationNumber?: string;

    constructor(
        sensorId: string, 
        parkingId: number, 
        registrationNumber: string
    ) {
        super();
        this.SensorID = sensorId;
        this.ParkingID = parkingId;
        this.RegistrationNumber = registrationNumber;
    }
}